import { Typography } from "@mui/joy";
import { currencyColumn, dateColumn, genericColumn, getColumnValue, numberColumn, textColumn, yesNoColumn } from "./columnHelpers";

export const employeesRelationship = {
    collapsible: true,
    title: 'Employee Records',
    tint: 'default',
    type: 'table',
    columns: [
        textColumn({label: 'Full Time', column: 'full_time'}),
        textColumn({label: 'Part Time', column: 'part_time'}),
        textColumn({label: 'Seasonal', column: 'seasonal'}),
        dateColumn({label: 'Date', column: 'date'}),
    ],
};
